import { memo, useCallback } from 'react'

import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { CtaBar } from 'modules/cta-bar'
import { Layout } from 'modules/layout'
import { buildSimulatorUrl } from 'src/utils/buildSimulatorUrl'
import { pushDataLayer } from 'utils/push-data-layer'

import Hero from './hero'

const Benefits = dynamic(() => import('./benefits'))
const Description = dynamic(() => import('./description'))
const Fiduciary = dynamic(() => import('./fiduciary'))
const Myths = dynamic(() => import('./myths'))
const HowWorks = dynamic(() => import('./how-works'))
const Feedbacks = dynamic(() => import('modules/feedbacks'))
const Help = dynamic(() => import('./help'))
const Modalities = dynamic(() => import('./modalities'))

const HomeEquity = memo(() => {
  const router = useRouter()

  const handleClick = useCallback(
    (clickTarget: string, label: string) => {
      pushDataLayer({
        category: 'Clique',
        action: 'Botões',
        label: `${clickTarget} - Home Equity - ${label}`
      })

      location.href = buildSimulatorUrl(router.pathname, { medium: clickTarget + '-' + label })
    },
    [router.pathname]
  )

  return (
    <Layout hasCTA>
      <Hero onClick={() => handleClick('Banner', 'Simular agora')} />
      <Description onClick={() => handleClick('O que é', 'Simular agora')} />
      <Benefits />
      <Fiduciary />
      <Myths />
      <HowWorks onClick={() => handleClick('Como Funciona', 'Simular agora')} />
      <Feedbacks />
      <Help />
      <Modalities />
      <CtaBar
        title="Simule agora o seu empréstimo"
        buttonLabel="Simular agora"
        onClick={() => handleClick('Flutuante', 'Simular agora')}
      />
    </Layout>
  )
})

HomeEquity.displayName = 'HomeEquity'

export default HomeEquity
